// ── Mentor / Student Program — Shared TypeScript Types ────────────────────────

/** Status values for a MentorInvitation */
export const INVITATION_STATUS = {
  PENDING: "pending",
  ACCEPTED: "accepted",
  DECLINED: "declined",
  REVOKED: "revoked",
  EXPIRED: "expired",
} as const;

export type InvitationStatus = (typeof INVITATION_STATUS)[keyof typeof INVITATION_STATUS];

/** Notification type values for a MentorNotification */
export const NOTIFICATION_TYPE = {
  INVITATION_RECEIVED: "invitation_received",
  INVITATION_ACCEPTED: "invitation_accepted",
  INVITATION_DECLINED: "invitation_declined",
  RELATION_REVOKED: "relation_revoked",
  MENTOR_NOTE_ADDED: "mentor_note_added",
} as const;

export type NotificationType = (typeof NOTIFICATION_TYPE)[keyof typeof NOTIFICATION_TYPE];

/** Permission keys that can be toggled per student */
export type StudentPermissionKey =
  | "canViewJournal"
  | "canViewDashboard"
  | "canViewAnalytics"
  | "canViewSessions"
  | "canViewPropFirmManager";

/** All 5 permission toggles */
export interface StudentPermissionsData {
  canViewJournal: boolean;
  canViewDashboard: boolean;
  canViewAnalytics: boolean;
  canViewSessions: boolean;
  canViewPropFirmManager: boolean;
}

/** Active relation with permissions, returned by assertMentorAccess */
export interface ActiveMentorRelation {
  id: string;
  mentorId: string;
  studentId: string;
  isActive: boolean;
  createdAt: Date;
  permissions: StudentPermissionsData;
}

/** Invitation expiry duration in days */
export const INVITATION_EXPIRY_DAYS = 7;

/** Max number of students per batch invite */
export const MAX_BATCH_INVITE = 50;
